export const getCrimeTypes = (selectedSource) => {
  if (selectedSource === 'BJS_NCVS') {
    return [
      { value: 'all_crime', label: 'Victimizations' },
      { value: 'violent_crime', label: 'Violent Crime', subTypes: [
        { value: 'rape', label: 'Rape' },
        { value: 'robbery', label: 'Robbery' },
        { value: 'aggravated_assault', label: 'Aggravated Assault' },
        { value: 'simple_assault', label: 'Simple Assault' }
      ]},
      { value: 'property_crime', label: 'Property Crime', subTypes: [
        { value: 'burglary', label: 'Burglary' },
        { value: 'trespassing', label: 'Trespassing' },
        { value: 'larceny_theft', label: 'Larceny/Theft' },
        { value: 'motor_vehicle_theft', label: 'Motor Vehicle Theft' }
      ]}
    ];
  }

  return [
    { value: 'all_crime', label: 'Crime' },
    { value: 'violent_crime', label: 'Violent Crime', subTypes: [
      { value: 'murder', label: 'Murder' },
      { value: 'rape', label: 'Rape' },
      { value: 'robbery', label: 'Robbery' },
      { value: 'aggravated_assault', label: 'Aggravated Assault' }
    ]},
    { value: 'property_crime', label: 'Property Crime', subTypes: [
      { value: 'burglary', label: 'Burglary' },
      { value: 'larceny_theft', label: 'Larceny/Theft' },
      { value: 'motor_vehicle_theft', label: 'Motor Vehicle Theft' }
    ]}
  ];
};

export const getCrimeDisplayName = (crimeType, selectedSource) => {
  const findInTypes = (types) => {
    for (const type of types) {
      if (type.value === crimeType) return type.label;
      if (type.subTypes) {
        const subType = type.subTypes.find(sub => sub.value === crimeType);
        if (subType) return subType.label;
      }
    }
    return crimeType;
  };
  
  return findInTypes(getCrimeTypes(selectedSource));
};

export const crimeTypes = getCrimeTypes('FBI_CIUS');

export const weightedPercentages = {
  'all_crime': '100%',
  'violent_crime': '80%',
  'murder': '30%',
  'rape': '20%',
  'robbery': '15%',
  'aggravated_assault': '15%',
  'property_crime': '20%',
  'burglary': '10%',
  'larceny_theft': '5%',
  'motor_vehicle_theft': '5%'
};